import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./rim-repair-layout.template.vue";

@Component({
  mixins: [template]
})
export default class RimRepairLayoutComponent extends Vue {
  @Prop({ default: "" }) public title!: string;
  @Prop({ default: "" }) public preTitle!: string;
  @Prop({ default: "160" }) public height!: string;
  @Prop({ default: "0" }) public padding!: string;
  @Prop({ default: null }) public backTo: string | undefined;

  goTo(): void {
    if (this.backTo && this.$route.path !== this.backTo)
      if (this.backTo === "back") {
        this.$router.back();
      } else {
        this.$router.push(this.backTo);
      }
  }

  get formatedHeight() {
    return `${this.height}px`;
  }

  get formatedPadding() {
    return `${this.padding}px 14px`;
  }
}
